import { render, staticRenderFns } from "./UserGenericEditor.vue?vue&type=template&id=7dc053c7"
import script from "./UserGenericEditor.vue?vue&type=script&lang=ts"
export * from "./UserGenericEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports